export default __webpack_public_path__ + "static/media/14B.030.e70d79dd.png";